<template>

<section class="hero-tutorials-img">
				<div class="">
          <div class="row">
            <div class="col-lg-12 pt-5">
              <img :src="`assets/img/user.png`" class="img-responsive pl-3" />
              <img :src="`assets/img/computer.png`" class="img-responsive right-side-image pr-3" />
            </div>
          </div>				
				</div>
		</section>
  <div class="container mt-4 margin_60_35">
    <div class="col-12 tutorial-filter-area">
      <div class="row">
        <div class="col-lg-4 col-md-4" v-if="categorylist">
          <select
            @change="getTutorials"
            class="d-inline form-control"
            v-model="selectedcategory.Id"
          >
            <option selected value="0">All Categories</option>
            <option
              v-for="category in categorylist"
              :key="category.Id"
              :value="category.Id"
              >{{ category.Title }}</option
            >
          </select>
        </div>
        <div class="col-lg-6 col-md-5">
          <!-- <div class="form-group">
            <input @change="getTutorials" v-model="searchText" class="form-control" type="text" placeholder="Search"/>
            <i class="fa fa-search" aria-hidden="true"></i>
          </div> -->
          <div class="tutorial-searchBar">
            <input @change="getTutorials" v-model="searchText" class="tutorial-filter-search" type="text" placeholder="Search"/>
            <button class="search-icon"><i class="fa fa-search" aria-hidden="true"></i></button>
          </div>
        </div>
        <div class="col-lg-2 col-md-3">
          <button
            class=" btn_1 full-width"
            @click="clearOnClick">
          Clear all
          </button>
        </div>
      </div>
      <!-- /row -->
    </div>
    <!-- /custom-search-input-2 -->
    <div class="isotope-wrapper mt-3" v-if="tutoriallist.length > 0">
      <div
        class="box_list isotope-item "
        v-for="tutorial in tutoriallist"
        :key="tutorial.Id"
        :value="tutorial.Id"
      >
        <div class="row no-gutters">
          <div class="col-lg-12">
            <div class="wrapper">
              <h3>
                <router-link
                  :to="{
                    name: 'TutorialDetails',
                    params: { tutorialId: tutorial.Id },
                  }"
                >
                  {{ tutorial.Title }}</router-link
                >
              </h3>
              <p
                v-html="this.$options.filters.truncate(tutorial.Body, 350)"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="p-4" v-else>No data found</p>
    <!-- /isotope-wrapper -->
  </div>
</template>

<script>
import CategoryService from '../services/category-service'
import TutorialService from '../services/tutorial-service'

export default {
  name: 'TutorialList',
  data() {
    return {
      selectedcategory: { Title: 'All Category', Id: 0 },
      categorylist: [],
      tutoriallist: [],
      searchText: null,
    }
  },
  filters: {
    truncate: function(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...'
      } else {
        return text
      }
    },
  },
  mounted() {
    this.getCategory()
    this.getTutorials()
  },
  methods: {
    getCategory() {
      CategoryService.getcategoryList().then((response) => {
        this.categorylist = response.data.Object.categories
      }),
      (error) => {
        console.log(error)
      }
    },
    getTutorials() {
      this.tutoriallist = ''
      TutorialService.getFilteredTutorials(
        this.selectedcategory.Id,
        this.searchText
      ).then((response) => {
        this.tutoriallist = response.data.Object.tutorials
      })
    },
    clearOnClick() {
      this.selectedcategory.Id = 0
      this.searchText = ''
      this.getTutorials()
    },
  },
}
</script>
